define('app/components/drivers/driversController.js',[], function() {
	function driversController($scope, $routeParams, $timeout, $window) {
		if ( !app ) {
			app = getQlikApp();
			gapp = app;
		}

		app.clearAll();

		$scope.qIds = [];

		//driverTable data
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['drivername']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Sum(results.points)'
				}
			}, {
				qDef: {
					qDef: 'Count( {$<[results.position]={1}>} [results.position])'
				}
			}, {
				qDef: {
					qDef: 'Count( {$<[results.position]={1,2,3}>} [results.position])'
				}
			}, {
				qDef: {
					qDef: 'Count({<DriverChampionFlag={1}>} distinct year)'
				}
			}, {
				qDef: {
					qDef: 'only([drivers.nationality])'
				}
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInitialDataFetch: [{
				qHeight: 850,
				qWidth: 6
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(driver, i) {
				var obj = {
					name: driver[0].qText,
					points: driver[1].qNum,
					wins: driver[2].qNum,
					podiums: driver[3].qNum,
					championships: driver[4].qNum,
					country: driver[5].qText
				};
				data.push(obj);
			});
			$scope.driverTableData = data;
		});

		//driver totals
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[drivername]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: '=$(vDriverTotal)'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.driverTotals = data;
		});

		//driver percents
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[drivername]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: '=$(vDriverPct)'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.driverPercents = data;
		});

		//by country
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[Driver Country Code]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Count({<DriverChampionFlag={1}>} distinct year)'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.byCountry = data;
		});

		/********* FILTERS ******/
		app.createList({
			qDef: {
				qFieldDefs: ['drivername']
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 900
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.driverFilter = reply.qListObject;
		});

		app.createList({
			qDef: {
				qFieldDefs: ['constructors.name']
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 900
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.constructorFilter = reply.qListObject;
		});

		app.createList({
			qDef: {
				qFieldDefs: ['Driver Country']
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 900
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.driverCountryFilter = reply.qListObject;
		});

		app.createGenericObject({
			year: { 
				qListObjectDef: {
					qDef: {
						qFieldDefs: ["year"],
						qSortCriterias: [{
				        	qSortByNumeric: -1,
				        }]
					},
					qAutoSortByState: {
						qDisplayNumberOfRows: 1
					},
					qShowAlternatives: true,
					qInitialDataFetch: [{
						qHeight: 100
					}]
				}
			},
			month: {
				qListObjectDef: {
					qDef: {
						qFieldDefs: ["month"]
					},
					qShowAlternatives: true,
					qInitialDataFetch: [{
						qHeight: 12
					}]
				}
			}
		}, function(reply) {
			var years = _.flatten(reply.year.qListObject.qDataPages[0].qMatrix);
			var months = _.flatten(reply.month.qListObject.qDataPages[0].qMatrix);
			$scope.calendarFilter = {years: years, months: months};
		})
		/********** END FILTERS *********/

		//Current Selections
		app.getList('SelectionObject', function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.currentSelections = reply.qSelectionObject.qSelections;
		});

		$scope.$on("$routeChangeStart", function() {
			angular.forEach($scope.qIds, function (qId) {
				app.destroySessionObject(qId);
			});
		});


		//chart heading stuff
		$scope.toggle = function (chart) {
			$scope[chart].showOptions = !$scope[chart].showOptions;
		}
		$scope.blur = function (chart) {
			$timeout(function() {
				$scope[chart].showOptions = false;
			}, 200);
		}

		$scope.driverTotalChart = {
			title: 'CHAMPIONSHIPS',
			description: 'The number of championships won by each driver',
			titleOptions: ['CHAMPIONSHIPS', 'WINS', 'PODIUMS', 'POINTS'],
			descriptionOptions: ['The number of championships won by each driver',
						   'The number of wins by each driver',
						   'The number of podiums reached by each driver',
						   'The number of points by each driver'],
			valueOptions: ['Count({<DriverChampionFlag={1}>} distinct year)', 
					   'Count( {$<[results.position]={1}>} [results.position])',
					   'Count( {$<[results.position]={1,2,3}>} [results.position])',
					   'Sum([results.points])'],
			variable: 'vDriverTotal',
			showOptions: false
		};

		$scope.driverPctChart = {
			title: 'CHAMPIONSHIP %',
			description: 'Percentage of championships won based on championships won vs seasons raced',
			titleOptions: ['CHAMPIONSHIP %', 'WIN %', 'PODIUM %', 'POINTS %'],
			descriptionOptions: ['Percentage of championships won based on championships won vs seasons raced',
						   'Percentage of races won based on races won vs races entered',
						   'Percentage of podiums reached based on podiums reached vs races entered',
						   'Percentage of times a driver earned points'],
			valueOptions: ['Count({<DriverChampionFlag={1}>} distinct year) / Count(DISTINCT year)', 
					   'Count( {$<[results.position]={1}>} [results.position]) / Count(DISTINCT raceId)',
					   'Count( {$<[results.position]={1,2,3}>} [results.position]) / Count(DISTINCT raceId)',
					   'Count({<[results.points]={">0"}>} [results.points]) / Count(DISTINCT raceId)'],
			variable: 'vDriverPct',
			showOptions: false
		};

		$scope.updateChart = function (chart, i) {
			$scope[chart].title = $scope[chart].titleOptions[i];
			$scope[chart].description = $scope[chart].descriptionOptions[i];
			app.variable.setStringValue($scope[chart].variable, $scope[chart].valueOptions[i]);
		}


		//Filter stuff
		$scope.expandMobileFilters = false;
		$(window).resize(function() {
			if ($(window).width() < 1200) {
				$scope.showCompactFilters = true;
				$scope.showFullFilters = false;
			} else {
				$scope.showCompactFilters = false;
				$scope.showFullFilters = true;
			}
			$timeout(function() {
				$scope.$apply();
			});
		});
		$(window).trigger('resize');

	}

  	driversController.$inject=['$scope','$routeParams', '$timeout', '$window'];

  	return driversController;
});
